import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminApi } from '../api';

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('aegis_admin_token');
    if (!token) { setLoading(false); return; }
    adminApi.me().then(setAdmin).catch(() => localStorage.removeItem('aegis_admin_token')).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.login(email, password);
    localStorage.setItem('aegis_admin_token', r.token);
    setAdmin({ email: r.email, role: r.role });
    return r;
  };
  const logout = () => { localStorage.removeItem('aegis_admin_token'); setAdmin(null); };

  return <Ctx.Provider value={{ admin, loading, login, logout }}>{children}</Ctx.Provider>;
}

export const useAdminAuth = () => {
  const c = useContext(Ctx);
  if (!c) throw new Error('AdminAuthProvider missing');
  return c;
};
